import {BASE_URL} from "../../api/API";
import {Base64} from "js-base64";
import {useCallback, useEffect, useRef} from "react";
import {toPng} from "html-to-image";
import {useIsMobileHook} from "../../utils";
import {Button, Stack, TextField} from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import ImageIcon from "@mui/icons-material/AddPhotoAlternate";
import LoadoutCard from "./LoadoutCard";

const generateLoadoutUrl = (weapon, attachments) => {
    return `${BASE_URL}loadouts/${generateLoadoutId(weapon, attachments)}`
};
const generateTweetUrl = (weapon, attachments) => {
    const loadoutUrl = generateLoadoutUrl(weapon, attachments)
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(`Check out my ${weapon.name} build on @XDLoadout: \n\n${loadoutUrl}`)}`
}

export function generateLoadoutId(weapon, attachments) {
    let loadout = `${weapon.name}$${Object.values(attachments)?.filter((a) => a != null).map((a) => a.id)}`
    return Base64.encodeURI(loadout);
}

const LoadoutDisplayMenu = ({weapon, attachments}) => {
    const ref = useRef(null)
    const menuRef = useRef(null)

    useEffect(() => fetch(`${BASE_URL}preview/loadout/${generateLoadoutId(weapon, attachments)}`).catch((e) => {}),
        [weapon, attachments])

    const convert = useCallback(() => {
        if (ref.current === null) {
            return
        }

        toPng(ref.current, {cacheBust: true, height: 600, width: 1125})
            .then((dataUrl) => {
                const link = document.createElement('a')
                link.download = `${weapon.name}-xdloadout.png`
                link.href = dataUrl
                link.click()
            })
            .catch((err) => {
            })
    }, [ref, weapon, attachments])

    const isMobile = useIsMobileHook()
    return <Stack className='loadout-display-menu' ref={menuRef} direction={isMobile ? 'column' : 'row'}
                  alignItems='center'
                  justifyContent='center'
                  sx={{
                      paddingTop: '10px',
                      width: '100%',
                      height: {xs: 'auto', md: '40px'}
                  }}>
        <TextField
            id="loadout-share-link"
            defaultValue={generateLoadoutUrl(weapon, attachments)}
            InputProps={{
                readOnly: true,
            }}
            sx={{padding: {xs: '0 0 5px 0', md: '0 15px 0 0'}, width: {sx: '100%', md: '50%'}}}
        />
        <Button sx={{mr: '5px'}} variant="contained" onClick={() => window.open(generateTweetUrl(weapon, attachments), "_blank")}>
            <TwitterIcon sx={{paddingRight: '5px'}}/> Tweet Loadout
        </Button>
        <Button variant="contained" onClick={convert}>
            <ImageIcon sx={{paddingRight: '5px'}}/> Save Image
        </Button>
        <LoadoutCard menuRef={ref} loadout={generateLoadoutId(weapon, attachments)}/>
    </Stack>;
}

export default LoadoutDisplayMenu